import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function Hipaa() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="HIPAA Privacy Notice | Woods Spine & Wellness"
        description="Notice of Privacy Practices for Woods Spine & Wellness."
        canonical="https://woodsspine.com/hipaa"
      />
      <Navbar />
      <main className="flex-grow">
        <section className="bg-primary py-16 text-primary-foreground text-center">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">HIPAA Privacy Notice</h1>
            <p className="text-xl opacity-90">Notice of Privacy Practices</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <Card className="shadow-lg border-0">
              <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
                <p className="text-lg font-semibold mb-8">
                  THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Our Commitment to Your Privacy</h3>
                <p className="mb-4">
                  Woods Spine & Wellness is dedicated to maintaining the privacy of your protected health information (PHI). In conducting our business, we will create records regarding you and the treatment and services we provide to you. We are required by law to maintain the privacy of health information that identifies you.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">How We May Use and Disclose Your PHI</h3>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Treatment:</strong> We may use your PHI to treat you. For example, we may ask you to have laboratory tests, and we may use the results to help us reach a diagnosis.</li>
                  <li><strong>Payment:</strong> We may use and disclose your PHI in order to bill and collect payment for the services and items you may receive from us.</li>
                  <li><strong>Health Care Operations:</strong> We may use and disclose your PHI to operate our business. For example, we may use your PHI to evaluate the quality of care you received from us.</li>
                  <li><strong>Appointment Reminders:</strong> We may use and disclose your PHI to contact you and remind you of an appointment.</li>
                  <li><strong>Required by Law:</strong> We will use and disclose your PHI when we are required to do so by federal, state, or local law.</li>
                </ul>

                <h3 className="text-2xl font-bold text-primary mb-4">Your Rights Regarding Your PHI</h3>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Confidential Communications:</strong> You have the right to request that our practice communicate with you about your health and related issues in a particular manner or at a certain location.</li>
                  <li><strong>Requesting Restrictions:</strong> You have the right to request a restriction in our use or disclosure of your PHI for treatment, payment, or health care operations.</li>
                  <li><strong>Inspection and Copies:</strong> You have the right to inspect and obtain a copy of the PHI that may be used to make decisions about you, including patient medical records and billing records.</li>
                  <li><strong>Amendment:</strong> You may ask us to amend your health information if you believe it is incorrect or incomplete.</li>
                  <li><strong>Accounting of Disclosures:</strong> You have the right to request an "accounting of disclosures." This is a list of certain non-routine disclosures our practice has made of your PHI.</li>
                  <li><strong>Paper Copy of This Notice:</strong> You are entitled to receive a paper copy of our notice of privacy practices.</li>
                </ul>

                <h3 className="text-2xl font-bold text-primary mb-4">Changes to This Notice</h3>
                <p className="mb-4">
                  We reserve the right to revise or amend this Notice of Privacy Practices. Any revision or amendment to this notice will be effective for all of your records that our practice has created or maintained in the past, and for any of your records that we may create or maintain in the future.
                </p>

                <div className="bg-muted p-6 rounded-lg mt-8">
                  <p className="font-bold mb-2">Contact Information</p>
                  <p className="mb-2">If you have any questions about this notice, please contact:</p>
                  <p className="mb-1"><strong>Woods Spine & Wellness</strong></p>
                  <p className="mb-1">530 E LOOP 281 STE 103, Longview, TX 75605</p>
                  <p className="mb-1">Phone: (903) 215-8828</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
